import React, { useState, useEffect, useRef } from 'react';
import { ConstructorEventUpdateSQLStatus } from '../../../../Event/event';

const WordProblemFunMix = () => {
  const [currentQuestion, setCurrentQuestion] = useState({});
  const [userAnswer, setUserAnswer] = useState('');
  const [resultText, setResultText] = useState('');
  const correctSoundRef = useRef(null);
  const wrongSoundRef = useRef(null);

  
  const questions = [
  // 🟢 EASY (1–5)
  { text: "🍎 Emma had 5 apples. She bought 3 more.\n\nHow many apples does she have now?", answer: 8, emoji: "🍎" },
  { text: "🐶 Mia has 12 dog treats. She gave 4 to her puppy.\n\nHow many treats are left?", answer: 8, emoji: "🐶" },
  { text: "🚗 There are 3 cars. Each car has 4 wheels.\n\nHow many wheels in total?", answer: 12, emoji: "🚗" },
  { text: "🎈 There are 6 balloons. 2 flew away.\n\nHow many balloons are left?", answer: 4, emoji: "🎈" },
  { text: "🧃 Each kid drinks 2 juices. There are 10 kids.\n\nHow many juices are needed?", answer: 20, emoji: "🧃" },

  // 🟡 MEDIUM (6–10)
  { text: "🍌 Mrs. Sinclair baked 8 loaves of banana bread. She used 3 bananas for each loaf.\n\nHow many bananas did she use in total?", answer: 24, emoji: "🍌" },
  { text: "🎨 There are 5 shelves. Each shelf has 6 paint bottles.\n\nHow many bottles in total?", answer: 30, emoji: "🎨" },
  { text: "🎟️ Tickets cost $4 each. Leo bought 6 tickets.\n\nHow much did he spend?", answer: 24, emoji: "🎟️" },
  { text: "📚 Sarah read 15 pages on Monday and 12 on Tuesday.\n\nHow many pages did she read in total?", answer: 27, emoji: "📚" },
  { text: "🧁 A baker made 40 cupcakes. She gave away 18.\n\nHow many are left?", answer: 22, emoji: "🧁" },

  // 🟠 HARD (11–15)
  { text: "🏀 A coach has 5 teams. Each team has 9 players.\n\nHow many players in total?", answer: 45, emoji: "🏀" },
  { text: "🍕 A pizza shop sold 12 boxes, each with 8 slices.\n\nHow many slices were sold in total?", answer: 96, emoji: "🍕" },
  { text: "🐠 There are 7 fish tanks, each with 9 fish. 6 fish swam away in total.\n\nHow many fish are left?", answer: 57, emoji: "🐠" },
  { text: "📦 A box holds 9 markers. If you have 4 boxes, how many markers are there?", answer: 36, emoji: "📦" },
  { text: "🍩 A bakery makes 24 doughnuts per tray. They baked 3 trays.\n\nHow many doughnuts in total?", answer: 72, emoji: "🍩" },

  // 🔴 HARDER (16–20)
  { text: "🚌 There are 5 buses. Each bus carries 42 students.\n\nHow many students are there altogether?", answer: 210, emoji: "🚌" },
  { text: "🎒 A store sold 20 school bags in a week. Each bag costs $40.\n\nHow much money did they earn?", answer: 800, emoji: "🎒" },
  { text: "🍫 Lily bought 5 boxes of chocolates. Each box has 10 pieces. She ate 12 chocolates.\n\nHow many are left?", answer: 38, emoji: "🍫" },
  { text: "📖 A book has 120 pages. Jack reads 15 pages each day.\n\nHow many days will it take to finish the book?", answer: 8, emoji: "📖" },
  { text: "🎢 There are 8 rides in a park. Each ride has 15 seats. If 10 seats are empty in total,\n\nhow many people are riding?", answer: 110, emoji: "🎢" }

];

  const generateQuestion = () => {
    const random = questions[Math.floor(Math.random() * questions.length)];
    setCurrentQuestion(random);
    setUserAnswer('');
    setResultText('');
  };

  const checkAnswer = () => {
    const answer = parseInt(userAnswer);
    if (isNaN(answer)) {
      setResultText("❗ Please enter a number!");
      return;
    }

    if (answer === currentQuestion.answer) {
      setResultText("✅ Correct! You're a math star!");
      correctSoundRef.current.play();

      const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
    } else {
      setResultText(`❌ Oops! The correct answer is ${currentQuestion.answer}. Try again!`);
      wrongSoundRef.current.play();
    }
  };

  useEffect(() => {
    generateQuestion();
  }, []);

  const styles = {
    body: {
      fontFamily: "'Comic Sans MS', cursive",
      background: 'linear-gradient(to bottom right, #fff9d6, #ffe3f1)',
      textAlign: 'center',
      color: '#333',
      margin: 0,
      padding: '1rem',
      minHeight: '100vh',
      boxSizing: 'border-box'
    },
    header: {
      backgroundColor: '#f77f00',
      padding: '20px',
      fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
      color: 'white',
      boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
    },
    container: {
      maxWidth: '800px',
      margin: '0 auto',
      padding: '1rem'
    },
    card: {
      backgroundColor: '#fff',
      padding: '2rem',
      borderRadius: '20px',
      boxShadow: '0 6px 16px rgba(0,0,0,0.15)',
    },
    question: {
      fontSize: 'clamp(1rem, 2.5vw, 1.4rem)',
      margin: '20px 0',
      whiteSpace: 'pre-wrap'
    },
    input: {
      padding: '10px',
      fontSize: 'clamp(1rem, 2vw, 1.2rem)',
      width: '150px',
      borderRadius: '10px',
      border: '2px solid #fcbf49',
      textAlign: 'center'
    },
    button: {
      margin: '15px 10px',
      padding: '12px 25px',
      fontSize: 'clamp(1rem, 2vw, 1.2rem)',
      border: 'none',
      borderRadius: '12px',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      minWidth: '120px'
    },
    checkBtn: {
      backgroundColor: '#00b4d8',
      color: 'white'
    },
    nextBtn: {
      backgroundColor: '#ef476f',
      color: 'white'
    },
    result: {
      fontSize: 'clamp(1rem, 2vw, 1.3rem)',
      marginTop: '20px',
      fontWeight: 'bold',
      minHeight: '30px'
    },
    emoji: {
      fontSize: 'clamp(2.5rem, 6vw, 4rem)',
      marginTop: '15px'
    }
  };

  return (
    <div style={styles.body}>
      <div style={styles.header}>🧠 Word Problem Fun Mix</div>
      <div style={styles.container}>
        <div style={styles.card}>
          <div style={styles.emoji}>{currentQuestion.emoji}</div>
          <div style={styles.question}>{currentQuestion.text}</div>
          <div style={{ display: 'flex', justifyContent: 'center' }} >
            <input
              type="number"
              value={userAnswer}
              onChange={(e) => setUserAnswer(e.target.value)}
              placeholder="Your answer"
              style={styles.input}
            /></div>
          <br />
          <button style={{ ...styles.button, ...styles.checkBtn }} onClick={checkAnswer}>
            ✅ Check
          </button>
          <button style={{ ...styles.button, ...styles.nextBtn }} onClick={generateQuestion}>
            🔄 Next
          </button>
          <div style={styles.result}>{resultText}</div>
        </div>
      </div>
      <audio ref={correctSoundRef} src="https://cdn.pixabay.com/download/audio/2022/03/15/audio_44b6f535f3.mp3?filename=success-kids-8082.mp3" />
      <audio ref={wrongSoundRef} src="https://cdn.pixabay.com/download/audio/2022/03/15/audio_49d682b7f5.mp3?filename=wrong-3-199276.mp3" />
    </div>
  );
};

export default WordProblemFunMix;
